<!--
 * @Author: fengjiahua fenjiahua@qq.com
 * @Date: 2024-01-26 11:34:38
 * @LastEditors: fengjiahua fenjiahua@qq.com
 * @LastEditTime: 2024-02-19 13:41:32
-->
<script lang='ts' setup>
import { APP_ROUTER, checkLink, imageTransform } from '@qctsw/common'
import topicSwiper from '../components/swiper.vue'
import templatePageData from '../components/templatePageData.vue'
import gridImage from '../components/gridImage.vue'
import otherArticle from '../components/otherArticle.vue'
import topicCard from '../components/topicCard.vue'
import type { LocationShowCodeEnum, OtherArticle, PastTopic, TemplateTypeCode, TopicTemplateNewsItem } from '~/server/types'
import { topicBaseDetailApi, topicTemplateBaseDataApi, topicTemplatePageDataApi } from '@/server'
import { LOAD_STATE } from '~/shared/types'

const props = defineProps<{ topicId: string, templateTypeCode: TemplateTypeCode, bodyJson: Record<string, any> }>()

const topicData = reactive<{

  pastTopics: PastTopic[]
  otherArticle: OtherArticle[]
}>({

  pastTopics: [],
  otherArticle: [],
})

async function getData() {
  const loadState = ref(LOAD_STATE.INIT)
  const res = await useLoadState({
    state: loadState,
    key: 'topicTemplateBaseDataApi',
    fn: () => topicTemplateBaseDataApi({
      topicId: props.topicId,
      templateTypeCode: 3,
    }),
  })

  const baseData = res!.data

  topicData.pastTopics = baseData.pastTopics
  topicData.otherArticle = baseData.otherArticle
}
await getData()
</script>

<template>
  <div class="flex box flex-col w-full items-center pb-10">
    <div class="w-full">
      <img w-full :src="imageTransform(bodyJson?.div_0?.topCoverImg, {})">
    </div>
    <div w-1200px mt-3>
      <topicSwiper :topic-id="topicId" />
      <div class="flex w-full">
        <div class="list  w-[calc(100%-380px)]">
          <topicCard :title="bodyJson?.div_1?.title || '资讯'">
            <templatePageData mr-10 :topic-id="topicId" :template-type-code="3" :location-show-code="bodyJson?.div_1?.locationShowCode" />
          </topicCard>
        </div>
        <div w-380px overflow-hidden>
          <topicCard :title="bodyJson?.div_2?.title || '推荐专题'">
            <gridImage :to-page="APP_ROUTER.topicDetail" :template-type-code="3" :list="topicData.pastTopics" />
          </topicCard>

          <topicCard :title="bodyJson?.div_3?.title || '其他资讯'">
            <otherArticle :template-type-code="3" :list="topicData.otherArticle" />
          </topicCard>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang='scss' scoped>
.box{
  background-color: var(--bodyBg);
}
</style>
